<div class="create-claim claim-detail">

  <div class="page-header">
    <h1 class="page-title">{{ 'CLAIM_DETAIL_TITLE' | translate }}</h1>
  </div>
  <!-- ============ Section: 基本信息 ============ -->
  <section class="section">
    <div class="section-header-row">
      <h2 class="section-title">
        <span class="title-bar"></span>
        {{ 'GENERAL_INFO' | translate }}
      </h2>
      <span class="header-ref" *ngIf="claimNumber">#{{ claimNumber }}</span>
      <span class="status-chip" *ngIf="claimStatus"
        [style.color]="getStatusColor(claimStatus).color"
        [style.background-color]="getStatusColor(claimStatus).bg">
        <span class="status-chip-text">{{ getStatusLabel(claimStatus) | translate }}</span>
      </span>
    </div>

    <nz-spin [nzSpinning]="detailLoading" [nzTip]="'LOADING' | translate">
      <form class="section-body" [formGroup]="basicForm">
      <!-- Row 1: 参考类型 (radio) -->
      <div class="form-row pdf-order-type-row">
        <div class="radio-group">
          <span class="form-label">{{ 'CART_PROCESS_ORDER' | translate }}：</span>
          <label class="radio-item" *ngFor="let opt of selectedReferenceTypeOptions">
            <input type="radio" formControlName="referenceType" [value]="opt.value" />
            <span class="radio-circle"></span>
            <span class="radio-label">{{ opt.labelKey | translate }}</span>
          </label>
        </div>
      </div>

      <!-- Row 2: 索赔原因 / 索赔分类 / 索赔方式 -->
      <div class="form-row form-row--equal three-cols">
        <div class="filter-field dropdown-field pdf-field">
          <span class="field-label">{{ 'CLAIM_REASON' | translate }}</span>
          <span class="pdf-readonly-value">{{ claimTypeName }}</span>
        </div>
        <div class="filter-field dropdown-field pdf-field">
          <span class="field-label">{{ 'CLAIM_CATEGORY' | translate }}</span>
          <span class="pdf-readonly-value">{{ claimCategoryName }}</span>
        </div>
        <div class="filter-field dropdown-field pdf-field">
          <span class="field-label">{{ 'CLAIM_SCHEME' | translate }}</span>
          <span class="pdf-readonly-value">{{ ruleLevel2Name }}</span>
        </div>
      </div>

      <!-- Row 3: 是否自行寄回 (only shown when 索赔方式 is Return for Credit / Exchange / Return) -->
      <ng-container *ngIf="showSelfReturnSection">
      <div class="form-row pdf-self-return-row">
        <div class="radio-group">
          <span class="form-label">{{ 'CLAIM_CREATE_RETURN_METHOD' | translate }}：</span>
          <label class="radio-item" *ngFor="let opt of selfReturnOptions">
            <input type="radio" formControlName="selfReturn" [value]="opt.value" />
            <span class="radio-circle"></span>
            <span class="radio-label">{{ opt.labelKey | translate }}</span>
          </label>
        </div>
      </div>

      <!-- Self-return warehouse notice (shown only when 是否自行寄回 = 是) -->
      <div class="self-return-notice" *ngIf="isSelfReturnYes">
        <div class="notice-warning">
          <i nz-icon nzType="info-circle" nzTheme="fill" class="notice-icon"></i>
          <span class="notice-warning-text">
            {{ 'CLAIM_CREATE_RETURN_NOTICE' | translate }}
          </span>
        </div>
        <div class="notice-info">
          <span class="notice-info-text">{{ 'CLAIM_CREATE_WAREHOUSE_INFO' | translate }}</span>
        </div>
      </div>

      <!-- Customer pickup info (shown only when 是否自行寄回 = 否) -->
      <div class="form-row form-row--equal three-cols pickup-row" *ngIf="isSelfReturnNo">
        <div class="filter-field pdf-field">
          <span class="field-label">{{ 'CLAIM_CREATE_CONTACT_PERSON' | translate }}</span>
          <span class="pdf-readonly-value">{{ contactName }}</span>
        </div>
        <div class="filter-field pdf-field">
          <span class="field-label">{{ 'CLAIM_CREATE_CONTACT_TEL' | translate }}</span>
          <span class="pdf-readonly-value">{{ contactPhone }}</span>
        </div>
        <div class="filter-field address-field pdf-field">
          <span class="field-label">{{ 'CLAIM_CREATE_CUSTOMER_ADDRESS' | translate }}</span>
          <span class="pdf-readonly-value">{{ contactAddress }}</span>
        </div>
      </div>

      <!-- Row 4: 退货订单号 + 退货交货单号 -->
      <div class="form-row pickup-row" style="gap: 20px; margin-top: 20px;">
        <div class="return-field-order">
          <span class="field-label">{{ 'CLAIM_DETAIL_RETURN_SO' | translate }}</span>
          <span class="return-value" [title]="returnSo">{{ returnSo || '' }}</span>
        </div>
        <div class="return-field-dn">
          <span class="field-label">{{ 'CLAIM_DETAIL_RETURN_DN' | translate }}</span>
          <span class="return-value" [title]="returnDn">{{ returnDn || '' }}</span>
        </div>
      </div>

      <!-- Row 5: 快递单号 (shown only when 自行寄回) -->
      <!-- <div class="form-row form-row--equal pickup-row"
        *ngIf="isSelfReturnYes"
        style="gap: 20px; margin-top: 20px;">
        <div class="filter-field pdf-field">
          <span class="field-label">快递单号</span>
          <span class="pdf-readonly-value">{{ trackingNum }}</span>
        </div>
      </div> -->
      </ng-container>
      </form>
    </nz-spin>
  </section>

  <!-- ============ Section: 订单信息 / 索赔信息 ============ -->
  <section class="section">
    <h2 class="section-title">
      <span class="title-bar"></span>
      {{ isOrderMode ? ('CLAIM_CREATE_ORDER_INFO' | translate) : ('CLAIM_CREATE_CLAIM_INFO' | translate) }}
    </h2>

    <nz-spin [nzSpinning]="itemsLoading" [nzTip]="'LOADING' | translate">
      <div class="section-body">
        <div class="table-wrapper">
          <nz-table
            [nzData]="pagedDetailItems"
            [nzFrontPagination]="false"
            [nzShowPagination]="false"
            [nzScroll]="{ x: 'max-content' }"
            [nzLocale]="{ emptyText: ('CLAIM_DETAIL_EMPTY' | translate) }"
          >
            <thead>
              <tr>
                <th *ngIf="!isOrderMode" nzWidth="90px">{{ 'CLAIM_CREATE_INVOICE_NO' | translate }}</th>
                <th *ngIf="!isOrderMode" nzWidth="120px">{{ 'CLAIM_CREATE_INVOICE_ITEM' | translate }}</th>
                <th *ngIf="!isOrderMode" nzWidth="120px">{{ 'CLAIM_DETAIL_INVOICE_QTY' | translate }}</th>
                <th *ngIf="!isOrderMode" nzWidth="210px">{{ 'CLAIM_DETAIL_INVOICE_NET_VALUE' | translate }}</th>
                <th *ngIf="isOrderMode" nzWidth="90px">{{ 'CLAIM_DETAIL_ORDER_NO_ITEM' | translate }}</th>
                <!-- <th *ngIf="isOrderMode" nzWidth="120px">订单行号</th> -->
                <th *ngIf="isOrderMode" nzWidth="120px">{{ 'CLAIM_DETAIL_ORDER_QTY' | translate }}</th>
                <th *ngIf="isOrderMode" nzWidth="210px">{{ 'CLAIM_DETAIL_ORDER_NET_VALUE' | translate }}</th>
                <th nzWidth="120px">{{ 'CLAIM_DETAIL_MATERIAL_NO' | translate }}</th>
                <th *ngIf="isPriceDifferenceMode" nzWidth="220px">{{ 'CLAIM_DETAIL_UNIT_PRICE' | translate }}</th>
                <th nzWidth="130px" style="text-align: center">{{ 'CLAIM_DETAIL_CLAIM_QTY' | translate }}</th>
                <th nzWidth="180px">{{ 'CLAIM_DETAIL_CLAIM_NET_VALUE' | translate }}</th>
                <th nzWidth="120px">{{ 'CLAIM_DELIVERY_NO' | translate }}</th>
                <th nzWidth="100px">{{ 'DN_ITEM_NO' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of pagedDetailItems">
                <td *ngIf="!isOrderMode">{{ item.invoiceNo }}</td>
                <td *ngIf="!isOrderMode">{{ item.invoiceItemNo }}</td>
                <td *ngIf="!isOrderMode">{{ item.dnQuantity }}</td>
                <td *ngIf="!isOrderMode">{{ item.dnTotalValueWithTax }}</td>
                <td *ngIf="isOrderMode">{{ item.orderNo }}/{{ item.orderItemNo }}</td>
                <!-- <td *ngIf="isOrderMode">{{ item.orderItemNo }}</td> -->
                <td *ngIf="isOrderMode">{{ item.dnQuantity }}</td>
                <td *ngIf="isOrderMode">{{ item.orderTotalAmount }}</td>
                <td>{{ item.materialNumber }}</td>
                <td *ngIf="isPriceDifferenceMode">CNY {{ item.priceDifference }}</td>
                <td class="claim-qty-value" style="text-align: center; color: #007bc0 !important;">{{ item.claimQty }}</td>
                <td class="amount-cell">{{ item.claimAmount }}</td>
                <td>{{ item.deliveryNumber }}</td>
                <td>{{ item.dnItemNo }}</td>
              </tr>
            </tbody>
          </nz-table>
        </div>

          <!-- Pagination -->
          <div class="table-pagination">
            <span class="pagination-total">{{ 'TOTAL_ITEM' | translate: { total: detailItems.length } }}</span>
            <nz-pagination class="claim-pagination"
              [nzPageIndex]="detailPagination.pageIndex"
              [nzPageSize]="detailPagination.pageSize"
              [nzTotal]="detailItems.length">
            </nz-pagination>
          </div>
      </div>
    </nz-spin>
  </section>

  <!-- ============ Section: 其他 ============ -->
  <section class="section">
    <h2 class="section-title">
      <span class="title-bar"></span>
      {{ 'CLAIM_CREATE_OTHERS' | translate }}
    </h2>
    <form class="section-body" [formGroup]="otherForm">
      <div class="upload-section">
        <span class="upload-label">{{ 'CLAIM_CREATE_UPLOAD_FILE_LABEL' | translate }}</span>
        <ul class="attachment-list" *ngIf="attachments.length > 0">
          <li *ngFor="let att of attachments" class="attachment-item">
            <span class="attachment-left">
              <i nz-icon nzType="paper-clip" nzTheme="outline"></i>
              <span class="attachment-name">{{ att.name }}</span>
            </span>
          </li>
        </ul>
        <div class="attachment-empty" *ngIf="attachments.length === 0">
          <span>{{ 'CLAIM_DETAIL_NO_ATTACHMENT' | translate }}</span>
        </div>
      </div>
      <div class="remark-row">
        <span class="remark-label">{{ 'CLAIM_CREATE_REMARK' | translate }}：</span>
        <textarea class="remark-textarea" rows="4" formControlName="remark" [placeholder]="'CLAIM_CREATE_REMARK_PLACEHOLDER' | translate"></textarea>
      </div>
    </form>
  </section>

</div>
